module.exports = __webpack_public_path__ + "static/media/logo1.985560c3.webp";